import constant from '@/common/resources/constant'
import cookie from '@/common/utils/cookie'
import queryString from '@/common/utils/querystring'
import fp from 'lodash/fp'
import _ from 'lodash'
import {
  getAdultCertificationStatus,
  getUserProfile,
  postLogin,
  postLogout,
  postPooqzoneLogin,
} from '@/common/utils/request'
import { setUserID } from '@/common/utils/common'
import { setCookieAdultSetting } from '@/common/utils/adult'
import { SERVICE_LOCATION_KEY } from '@/common/resources/const'
import store from '@/store'
import braze from '@/common/utils/braze'
import { datadogRum } from '@datadog/browser-rum'

import { useConsentRenew } from '@/common/use/useConsentRenew'
const { storage } = useConsentRenew()

const alertFromServer = (message) => {
  if (!_.isNil(message) && message !== '') {
    alert(message.replace('\\\\n', '\n').replace('\\n', '\n'))
  }
}
const getCookieExpireDate = () => {
  const expires = new Date()
  expires.setHours(0, 0, 0, 0)
  expires.setDate(expires.getDate() + 365)
  return expires
}
const getOneYearExpireUTCString = () => getCookieExpireDate().toUTCString()
const assignData = (data) => _.assign({ isPooqzone: false }, data)
const assignIsPooqzone = (data) => _.assign({ isPooqzone: true }, data)
const setLoginUserInfoToCookie = (userDataJson) => {
  cookie.setItem(
    'cs',
    JSON.stringify(userDataJson),
    null,
    constant.URL_COOKIE_DOMAIN,
    '/',
  )
  store.commit('setCsInfo', cookie.userInfo())
}
export const setUserDataAsync = (data) => {
  const profileId = _.get(data, 'profile', '0')
  const credential = _.get(data, 'credential', '')
  const uno = _.get(data, 'uno', '')
  if (uno) {
    braze.changeUser(`${uno}_${profileId}`)
    datadogRum.setUser({ name: uno })
  }
  return getUserProfile(profileId, credential).then((response) => {
    const profileInfo = _.get(response, 'data', {})
    const { image, idx, alt, profilename } = profileInfo
    const adaptedProfile = _.assign({}, data, {
      profileimage: image,
      idx,
      alt,
      profilename,
    })
    fp.flow(assignData, setLoginUserInfoToCookie)(adaptedProfile)
    return data
  })
}
const isSaveUserID = (saveId) => !_.isNil(saveId) && saveId
// const isAutoLogin = autoLogin => autoLogin !== '' &&
export const saveIdProcess = ({ saveId = false, userId }) => {
  if (isSaveUserID(saveId)) {
    cookie.setItem(
      'userId',
      userId,
      getOneYearExpireUTCString(),
      constant.URL_COOKIE_DOMAIN,
      '/',
    )
  } else {
    cookie.removeItem('userId', constant.URL_COOKIE_DOMAIN, '/')
  }
}
export const setAutoLoginInfo = ({ autoLogin, credential }) => {
  if (autoLogin) {
    cookie.setAutoLoginCredential(credential)
  }
}

const getCredential = (data) => _.get(data, 'credential', '')

const isAutoLoginUser = () => {
  return (
    !cookie.isCsInfo() &&
    cookie.getAutoLoginCredential() &&
    !(window.location.pathname.startsWith('/index') && !cookie.wasSetWavveOn())
  )
}
const isVerifiedCredential = (credential) =>
  !_.isNil(credential) && credential !== '' && credential !== 'none'

const ifLoginFailThenRedirect = (response) => {
  const { data, status } = response
  const { resultcode, resultmessage } = data
  if (status === 551 && resultcode === '301') {
    alertFromServer(resultmessage)
    window.location.href =
      'member/login.html?referer=' + encodeURIComponent(location.href)
  }
}

const setSettings = () => {
  getAdultCertificationStatus().then(({ data }) => {
    setCookieAdultSetting('adult-settings', _.get(data, 'settings', 'N'))
  })
}
const deltetVerifiedAdult = () => {
  cookie.removeItem('verifiedAdult', constant.URL_COOKIE_DOMAIN, '/')
}
const routeToIndex = () => {
  window.location.href = '/index.html'
}

// Error의 두가지 케이스 1. 네트워크 에러 - catch가 잡는다. 2. 로그인상의 서버 에러 - 호출한 곳에서 처리
export const loginProc = async ({
  userType,
  userId,
  userPassword,
  saveId,
  autoLogin,
  profile = '0',
}) => {
  return postLogin({
    type: userType,
    id: userId,
    pushid: 'none',
    password: userPassword,
    profile: profile,
  })
    .then(({ data }) => {
      return setUserDataAsync(data)
    })
    .then((data) => {
      saveIdProcess({ saveId, userId })
      setAutoLoginInfo({ autoLogin, credential: getCredential(data) })
      setUserID(userId)
      setSettings()
      deltetVerifiedAdult()
      storage.setSessionConsentCheck('true')
      return data
    })
}

const autoLoginFromCookieKeyAndDelete = (cookieKey) => {
  const credential = cookie.getItem(cookieKey)
  return postLogin({
    type: 'credential',
    id: credential,
    pushid: '',
    password: '',
    profile: '',
  })
    .then(({ data }) => {
      return setUserDataAsync(data)
    })
    .then(() => {
      cookie.removeItem(cookieKey, constant.URL_COOKIE_DOMAIN, '/')
    })
}

export const autoLoginSetting = (credential, isMultiLine = false) => {
  cookie.removeItem('verifiedAdult', constant.URL_COOKIE_DOMAIN, '/')
  if (isVerifiedCredential(credential)) {
    return postLogin({
      type: 'credential',
      id: credential,
      pushid: '',
      password: '',
      profile: isMultiLine ? '0' : '',
    })
      .then((response) => {
        const { data } = response
        ifLoginFailThenRedirect(response)
        return data
      })
      .then((data) => {
        return setUserDataAsync(data)
      })
  } else {
    return new Promise((resolve, reject) => {
      resolve(true)
    })
  }
}

export const checkValidCredential = async (credential) => {
  const result = {
    isValid: false,
    response: null,
  }
  if (credential !== 'none') {
    try {
      const response = await postLogin({
        type: 'credential',
        id: credential,
        pushid: '',
        password: '',
        profile: '',
      })
      if (response?.status === 200) {
        result.isValid = true
      }
      result.response = response
    } catch (e) {
      result.response = e.response
    }
  }
  return result
}

const autoLoginProcess = () => {
  const credential = cookie.getAutoLoginCredential()
  return autoLoginSetting(credential).then((data) => {
    cookie.setAutoLoginCredential(getCredential(data))
    return data
  })
}

const COOKIE_KEY_SIGN_UP_CREDENTIAL = 'signup-credential'
const COOKIE_KEY_PASSWORD_CHANGE_CREDENTIAL = 'pwdChanged'
const COOKIE_KEY_MEMBER_LOG_OUT = 'member-logout'
const COOKIE_KEY_POOQ_ZONE_LOG_OUT = 'pooqzone-logout'
export const autoLoginProc = () => {
  if (isAutoLoginUser()) {
    return autoLoginProcess()
  } else if (cookie.hasItem(COOKIE_KEY_SIGN_UP_CREDENTIAL)) {
    // 회원가입 후
    return autoLoginFromCookieKeyAndDelete(COOKIE_KEY_SIGN_UP_CREDENTIAL)
  } else if (cookie.hasItem(COOKIE_KEY_PASSWORD_CHANGE_CREDENTIAL)) {
    return autoLoginFromCookieKeyAndDelete(
      COOKIE_KEY_PASSWORD_CHANGE_CREDENTIAL,
    )
  } else if (cookie.hasItem(COOKIE_KEY_MEMBER_LOG_OUT)) {
    return logoutProc().then(() => {
      cookie.removeItem(
        COOKIE_KEY_MEMBER_LOG_OUT,
        constant.URL_COOKIE_DOMAIN,
        '/',
      )
      routeToIndex()
    })
  } else if (cookie.hasItem(COOKIE_KEY_POOQ_ZONE_LOG_OUT)) {
    return logoutProc().then(() => {
      cookie.removeItems({
        keyList: [COOKIE_KEY_POOQ_ZONE_LOG_OUT, 'pzInfo', 'cs', 'pz'],
      })
      cookie.setItem(
        'pz',
        JSON.stringify({ isPooqzone: false }),
        false,
        constant.URL_COOKIE_DOMAIN,
        '/',
      )
      routeToIndex()
    })
  }
}

export const changeProfileProc = ({ profileId }) => {
  const credential = cookie.getCredential()
  // 성인인증 정보 삭제
  cookie.removeItem('verifiedAdult', constant.URL_COOKIE_DOMAIN, '/')
  if (isVerifiedCredential(credential)) {
    return postLogin({
      type: 'credential',
      id: credential,
      pushid: '',
      password: '',
      profile: profileId,
    })
      .then(({ data }) => {
        return setUserDataAsync(data)
      })
      .then((data) => {
        if (cookie.getAutoLoginCredential()) {
          cookie.setAutoLoginCredential(getCredential(data))
        }
        const needSelectProfile = _.get(data, 'needselectprofile', 'n')
        if (needSelectProfile === 'y') {
          window.location.href =
            '/member/profile_list.html?referer=' +
            encodeURIComponent(location.href)
        }
        return data
      })
  }
}

export const pooqzoneLoginProc = ({ pincode }) => {
  const pooqZoneTempInfo = cookie.getPooqZoneTempInfo()
  const pooqZoneId = _.get(pooqZoneTempInfo, 'pooqzoneid', '')
  return postPooqzoneLogin({ pooqzoneid: pooqZoneId, pincode: pincode }).then(
    ({ data }) => {
      cookie.removeItems({ keyList: ['pzInfo', 'pz', 'cs'] })
      cookie.setItem(
        'cs',
        JSON.stringify(assignIsPooqzone(data)),
        null,
        constant.URL_COOKIE_DOMAIN,
        '/',
      )
      cookie.setItem(
        'pz',
        JSON.stringify(assignIsPooqzone(pooqZoneTempInfo)),
        false,
        constant.URL_COOKIE_DOMAIN,
        '/',
      )
    },
  )
}

export const logoutProc = () => {
  return postLogout({ pushid: '' }).then(() => {
    cookie.removeItems({
      keyList: [
        'cs',
        'credential',
        'verifiedAdult',
        'SHARE_KEY',
        'adult-settings',
        'adult-isOtt',
        'targetage',
      ],
    })
    sessionStorage.removeItem(SERVICE_LOCATION_KEY)
    storage.removeSessionConsentCheck()
    Object.keys(localStorage).forEach((key) => {
      if (key !== 'guid' && key !== 'wavve-device-id') {
        localStorage.removeItem(key)
      }
    })
  })
}

export const multiProfileAutoLogin = () => {
  const credential = cookie.getCredential()
  const isMultiLine = Number(cookie.userInfo('profilecount')) !== 1
  return autoLoginSetting(credential, isMultiLine)
}

/**
 * 유저 로그아웃 처리를 위해 클라이언트에서 수행하는 로직 (api 호출 제외)
 * - 쿠키에서 유저 정보 삭제
 * - 세션스토리지, 로컬스토리지 정보 삭제
 */
export const clearStorageForLogout = (options = {}) => {
  cookie.removeItems({
    keyList: [
      'cs',
      'credential',
      'verifiedAdult',
      'SHARE_KEY',
      'adult-settings',
      'adult-isOtt',
      'targetage',
    ],
  })
  sessionStorage.removeItem(SERVICE_LOCATION_KEY)
  Object.keys(localStorage).forEach((key) => {
    if (key !== 'guid' && key !== 'wavve-device-id') {
      localStorage.removeItem(key)
    }
  })
}

/**
 * 쿠키 내 크리덴셜 관련 정보를 업데이트한다 (cs의 crednetial값, credential)
 * @param {string} credential 변경할 크리덴셜 값
 */
export const updateCredentialInCookie = (credential) => {
  if (!credential) return
  if (cookie.getAutoLoginCredential()) {
    cookie.setAutoLoginCredential(credential)
  }
  const csInfo = cookie.userInfo()
  csInfo.credential = credential
  cookie.setItem(
    'cs',
    JSON.stringify(csInfo),
    null,
    constant.URL_COOKIE_DOMAIN,
    '/',
  )
}

/**
 * 멤버 로그인 페이지 URL을 생성한다.
 * @param {Object} options
 * @param {string} options.type sns 로그인 타입 (kakao, naver, tid, facebook, apple)
 * @param {string} options.callback sns 로그인 후 콜백 URL
 * @returns {string} 멤버 sns 로그인 페이지 URL
 */
export const getMemberSnsLoginUrl = ({ type, callback }) => {
  if (!type || !callback) {
    return
  }
  const memberSnsLoginUrl = `https://member.wavve.com/sns/${type}/signin`
  const callbackUrl = queryString.concatParams(callback, { type })

  return `${memberSnsLoginUrl}?callback=${encodeURIComponent(callbackUrl)}`
}
